import getLuxLoyaltyDefaultTier from 'luxLoyalty/selectors/getLuxLoyaltyDefaultTier'

function getLuxLoyaltyEligibleTier(state: App.State): App.LuxLoyaltyTier {
  const eligibilityTier = state.luxLoyalty.eligibilityTier.data

  return eligibilityTier ?? getLuxLoyaltyDefaultTier()
}

export default getLuxLoyaltyEligibleTier
